import React from 'react';
import { observer } from 'mobx-react';

import { useHeadingLinksCombiner } from '../../hooks/useHeadingLinksCombiner/useHeadingLinksCombiner';
import Logo from '../Logo/Logo';
import MenuItems from '../MenuItems/MenuItems';

import styles from './HeadingLinks.module.scss';

function HeadingLinks() {
  const {
    logo,
    items,
    isLogo,
    logoSource,
    isNpvrEnabled,
    isOnBoardingView,
    isOnBoardingWihoutLogo,
  } = useHeadingLinksCombiner();

  if (isOnBoardingWihoutLogo) {
    return null;
  }

  return (
    <nav className={styles.nav}>
      {isLogo && <Logo description={logo?.data.linkItem?.name} key={logo?.data.linkItem?.id} image={logoSource} />}
      {!isOnBoardingView && <MenuItems items={items} isNpvrEnabled={isNpvrEnabled} />}
    </nav>
  );
}

export default observer(HeadingLinks);
